import { HealthTeam } from "@/@types/esus/HealthTeam";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeIndicatorC6ByHealthTeamParams = Partial<PaginationFilter> & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	export?: boolean;
};

export class ResumeIndicatorC6ByHealthTeamData {
	healthTeam?: HealthTeam;
	totalElderlyCitizensInPeriod: number = 0;
	totalElderlyCitizensInPeriodScore: number = 0;
	maxElderlyCitizensInPeriodScore: number = 0;
}

export async function getResumeIndicatorC6ByHealthTeam({
	uf,
	ibgeCode,
	...params
}: ResumeIndicatorC6ByHealthTeamParams) {
	const response = await esusApi.get<Paginated<ResumeIndicatorC6ByHealthTeamData>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c6/health-teams-resume`,
		params
	);
	return response.data ?? new Paginated<ResumeIndicatorC6ByHealthTeamData>();
}
